var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.history},scopedSlots:_vm._u([{key:"item.updatedAt",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$options.filters.formatDate(item.updatedAt, ('L LT')))+" ")]}},{key:"item.updatedBy",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.updatedBy.user.profile.firstName)+" "+_vm._s(item.updatedBy.user.profile.lastName)+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }